<template>
    <div> 
        <div class="content">
            <div class="title-box">
                <h3>{{mtclient.indexText}}</h3>
            </div>
            <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">  
                <div class="btn-group">
                    <button class="btn btn-default" v-for="(item,key) in mtdbs" @click="changeMT(item.name)" :class="{'active': item.name==selDb}">
                         {{`${item.serverName}(${item.mtType})`}}
                    </button>
                </div>
                <mtable v-if="trData"
                :thData="thData"
                :trData="trData"
                :selPage="selPage"
                :page="page"
                :name="name"
                :sort="sort"
                :multiLanguage="mtclient"
                :jsonExcelAjax="jsonExcelAjax"
                :downLoadTran="downLoadTran"
                @tableChange="tableAjax">
                    <div slot="handle" class="monthlyHandle">
                        <el-input v-model="login" size="medium">
                            <template slot="prepend">{{mtclient.loginText}}</template>
                            <el-button slot="append" @click="searchData" size="medium">{{mtclient.search}}</el-button>
                        </el-input>
                    </div>
                </mtable>
            </div>
        </div>
    </div>
</template>
<script>
import mtable from "../../comm/mytable"
import {formatDate,getTimeDiff,updateTimeByUtc} from 'common/js/util'
import { URL_MTCLIENTS, URL_MTDBS } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
    name:'monthlyIBResult',
    mixins: [
      require("common/mixin/base.js").base({mtclient: "mtclient"})
    ],
    props: ['curArea'],
    data() {
        return {
            trData: [],
            login: '',
            url: "",
            loading: false,
            page: {
                active: 1,
                pageLeng: 0
            },
            selPage: {
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            },
            sort: {  
                key: "",
                method: "ASC"
            },
            mtdbs: [],
            selDb: 'mt4',
        }
    },
    created(){
        let requrl = api.getUrl20(this.curArea,URL_MTDBS)
        this.$http.get(requrl).then((res) => {
            this.mtdbs = res.data.data.rows
            if(this.mtdbs && this.mtdbs.length>0) this.selDb = this.mtdbs[0].name
            this.tableAjax();
        })
    },
    methods: {
        searchData(){
            this.page.active = 1
            this.tableAjax()
        },
        changeMT(mt){
            this.selDb = mt
            this.tableAjax()
        },
        tableAjax(){
            this.loading = true
            this.url = api.getUrl20(this.curArea,URL_MTCLIENTS)
            let obj = {
                params: {
                    login: this.login,
                    sortKey: this.sort.key,
                    sortVal: this.sort.method,
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit,
                    mtdb: this.selDb,
                }
            }
            this.$http.get(this.url, obj).then((res) => {
                this.trData = res.data.data.rows
                this.page.pageLeng = res.data.data.count
                this.setOfficeState()
                this.loading = false
            })
        },
        setOfficeState() {
            let status = this.mtclient.status
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach(item => item.enable = (item.ENABLE || item.ENABLE == 0) ? status[item.ENABLE] : '');
            }
        }
    },
    computed:{
        name(){
            return this.mtclient.indexText
        },
        downLoadTran(){
            return {ENABLE: this.mtclient.status}
        },
        thData(){
            return this.mtclient.tableHead
        },
        jsonExcelAjax () {
            return { url: this.url, ajaxType: "get", getKey: ["data", "data",'rows'],
                ajaxPar: { 
                    login: this.login, 
                    sortKey: this.sort.key,
                    sortVal: this.sort.method,
                    pageSize: this.page.pageLeng, 
                    mtdb: this.selDb,
                    pageNum: 0 
                }
            }
        }
    },
    watch: {
        mtclient(){
            this.setOfficeState()
        },
        curArea(){
            this.page.active = 1
            this.tableAjax()
        }
    },
    components:{
        mtable
    }
}
</script>
<style lang="scss" type="text/scss" scoped>
    .title-box{
        border: 1px solid #3F51B5;
        background: #3F51B5;
        padding: 0 20px;
        color: #fff;
        border-radius: 5px 5px 0 0;
    }
    .monthlyHandle{
        float: left;
        margin-right:30px;
        margin-top:-9px; 
        .el-button--default {
            background: #2196F3;
            color: #fff;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .btn-group{
         margin-left: 20px;
         margin-top: 10px;
         .active{
             background-color: #F08712;
             color: #fff;
         }
     }
</style>



// WEBPACK FOOTER //
// mtclientReport.vue?251329c0